import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LANGUAGES } from '@savgroup-front-common/constants';
import {
  changeLocaleLanguage,
  setUserLanguagePreference,
} from '@savgroup-front-common/core/domains/i18n/actions';

import { useAppContext } from '@/view/app/App.context';

export function useProfileActions() {
  const { logout: signout } = useAppContext();
  const dispatch = useDispatch();

  const updateIntl = useCallback(
    (locale: LANGUAGES) => {
      dispatch(setUserLanguagePreference({ locale }));
      dispatch(changeLocaleLanguage({ locale }));
    },
    [dispatch],
  );
  const logout = useCallback(() => signout(), [signout]);

  return {
    logout,
    updateIntl,
  };
}
